module.exports = __webpack_public_path__ + "static/img/course3.0344557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course3.png
// module id = bSSv
// module chunks = 63